/* eslint-disable react/react-in-jsx-scope */
import { useAuth } from "@/auth/hooks/useAuth";
import { useSession } from "@/broadcastChannel/useSession";
import ImpersonationBanner from "@/dashboard/components/layout/ImpersonationBanner";
import { FC, ReactNode, useEffect } from "react";

const LayoutSubmitCallForProjects: FC<{ children: ReactNode }> = ({ children }) => {
  const { session } = useSession();
  const { user } = useAuth();
  const showAdminSubcontractorBanner =
    typeof window !== "undefined" &&
    localStorage.getItem("isImpersonating") === "true" &&
    user?.roles?.includes("ROLE_SUBCONTRACTOR");

  useEffect(() => {
    const isSubcontractor = localStorage.getItem("isSubcontractor");
    const slugName = localStorage.getItem("slugName");
    const link = localStorage.getItem("link");
    const jwtToken =
      localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");

    if (!jwtToken && isSubcontractor && slugName && link) {
      window.location.href = `/authentification-cfp/${link}/${slugName}`;
    } else if (!jwtToken && !isSubcontractor && !slugName && !link) {
      window.location.href = "/login";
    }
  }, [session]);

  return (
    <div id="container-main" className="relative min-h-screen bg-[#f6f8f4]">
      <ImpersonationBanner visible={Boolean(showAdminSubcontractorBanner)} />
      <div className="container pb-6 pt-16 md:pt-24">
        <main className="min-h-[70vh]">{children}</main>
      </div>
    </div>
  );
};

export default LayoutSubmitCallForProjects;
